@import "../shared.css";

:host {
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-wrap: wrap;
	overflow: hidden;
	position: relative;
	width: 100%;
	padding-left: var(--input-padding-side);
	background-color: rgb(var(--smoothly-input-background));
	box-sizing: border-box;
}

:host>div>div.drag-overlay {
	position: absolute;
	inset: 0;
	background-color: rgb(var(--smoothly-input-hover-background), 0.6);
	border-radius: var(--smoothly-input-border-radius);
	border: 0.25rem dashed rgb(var(--smoothly-input-hover-foreground));
	display: flex;
	justify-content: center;
	align-items: center;
}
:host>div>div.drag-overlay>smoothly-icon {
	color: rgb(var(--smoothly-input-hover-foreground));
}

:host:not(.dragging)>div>div.drag-overlay {
	display: none;
}

:host>div.input>input {
	overflow: hidden;
	height: 0;
	width: 0;
	padding: 0;
}

:host:not([show-label])>div.input {
	display: flex;
	align-items: center;
	padding-bottom: 0.2rem;
}

:host:not([show-label])>smoothly-button:not(:empty) {
	margin-right: 1ch;
}

:host([show-label]) > div.input {
	display: flex;
	padding-block: var(--input-value-padding-top) var(--input-value-padding-bottom);
	height: 100%;
	box-sizing: border-box;
	flex-grow: 1;
}

:host>div>smoothly-button {
	--smoothly-button-height: 1.4rem;
	margin: 0;
	border: none;
}

:host>label {
	left: var(--input-padding-side);
}

:host:not([readonly]),
:host:not([readonly]) * {
	cursor: pointer;
}

:host[disabled],
:host[disabled] * {
	cursor: not-allowed;
}
